import { MotifFormField, MotifLabel, MotifOption, MotifSearch, MotifSelect } from '@ey-xd/motif-react'
import React from 'react'

const WorkspaceSearchAndFilter = (props: any) => {
    const {search, setSearch, subdomain, setSubdomain} = props;
    return (
        <div className="motif-row items-center mb-3">
            <div className="motif-col-sm-2">
                <p>Below listed are the workspace created by you:</p>
            </div>
            <div className="motif-col-sm-2 flex gap-2 filterInputs">
                <MotifFormField className="!w-full !mb-0">
                    <MotifSearch
                        aria-label="Search"
                        id="states-search"
                        onChange={(e) => {
                            setSearch(e.target.value);
                        }}
                        // onSearchButtonClick={searchButtonClicked}
                        onSelect={function Xo() { }}
                        placeholder="Search for..."
                        value={search}
                    />
                </MotifFormField>
                <MotifFormField className="!w-full !mb-0">
                    <MotifLabel id="select-label">
                        Sub-domain(required)
                    </MotifLabel>
                    <MotifSelect
                        ariaLabelledBy="select-label"
                        onChange={(val) => {
                            setSubdomain(val);
                        }}
                        placeholder=""
                        value={subdomain ?? ""}
                        // visibleOptions={3}
                    >
                        <MotifOption value="esg">
                            ESG
                        </MotifOption>
                        <MotifOption value="sap">
                            SAP
                        </MotifOption>
                        <MotifOption value="cyber">
                            Cyber
                        </MotifOption>
                        <MotifOption value="risk">
                            Risk
                        </MotifOption>
                    </MotifSelect>
                </MotifFormField>
            </div>
        </div>
    )
}

export default WorkspaceSearchAndFilter